import React from 'react'
import moment from 'moment'

Number.prototype.formatMoney = function (c, d, t) {
  var n = this,
    c = isNaN(c = Math.abs(c)) ? 2 : c,
    d = d == undefined ? "." : d,
    t = t == undefined ? "," : t,
    s = n < 0 ? "-" : "",
    i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
    j = (j = i.length) > 3 ? j % 3 : 0;
  return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
}

function formatValue(row, key) {
  // row: array of obj
  // key: obj key
  const val = row[key]
  if (isNaN(val) || val === '')
    return val
  return parseFloat(val).formatMoney(2)
}

// const moneyFormatter = new Intl.NumberFormat('en-US', {
//   // style: 'currency',
//   // currency: 'USD',
//   // minimumFractionDigits: 2,
//   // the default value for minimumFractionDigits depends on the currency
//   // and is usually already 2
// })
const moneyFormatter = {
  format(input){
    return parseFloat(input).formatMoney()
  }
}
const momentHelper = {
  getMonth() {
    const monthNumber = new Date().getMonth() + 1
    return ('0000' + monthNumber).slice(-2)
  },

  getMonthText(monthNumber) {
    return monthNumber !== '00' ? moment(monthNumber).format('MMMM') : 'ทั้งปี'
  },

  getYear() {
    return (new Date().getFullYear() * 1 + 543)
  },

  getThaiYear(date) {
    // date format: DD / MM / YYYY
    if (date.lastIndexOf("/") > date.length - 5) return ""
    return date.slice(date.lastIndexOf("/") + 1) * 1 + 543 + ""
  },

  getWorldYear(date) {
    // date format: DD / MM / YYYY
    if (date.lastIndexOf("/") > date.length - 5) return ""
    return date.slice(date.lastIndexOf("/") + 1) * 1 - 543 + ""
  },

  convertThaiToWorldYear(date){
    if (date.lastIndexOf("/") > date.length - 5) return ""
    return  date.substring(0,date.lastIndexOf("/")+1 )+ (date.slice(date.lastIndexOf("/") + 1) * 1 - 543)
  },

  convertWorldToThaiYear(date){
    if (date.lastIndexOf("/") > date.length - 5) return ""
    return  date.substring(0,date.lastIndexOf("/")+1 )+ (date.slice(date.lastIndexOf("/") + 1) * 1 + 543)
  },

  getFullDate(date) {
    // moment.locale('th')
    const dayMonth = date.slice(0, date.lastIndexOf("/"))
    return moment(dayMonth).format('Do MMMM') + " " + this.getThaiYear(date)
  },

  getThaiDate(date) {
    // input date format = DD/MM/YYYY
    const dayMonth = date.slice(0, date.lastIndexOf("/"))
    return dayMonth + '/' + this.getThaiYear(date)
  }
}

const tableHelper = {
  formatValue(row, key) {
    // row: array of obj
    // key: obj key
    const val = row[key]
    // if (key.indexOf('Date') !== -1 && val.lastIndexOf("/") !== -1)
    //   return val.slice(0, val.lastIndexOf("/"))
    //     + "/"
    //     + momentHelper.getThaiYear(val).slice(2)
    if (isNaN(val) || val === '')
      return val
    if (typeof val === 'object')
      return val
    return parseFloat(val).formatMoney(2)
  },

  addLineBreak(val) {
    const divStyle = {
      whiteSpace: 'pre-line'
    }
    return (
      <div
        style={divStyle}
        className='text-left'
      >
        {val}
      </div>
    )
  },

  renderHeader(titles) {
    const ths = titles.map((title, i) => (
      <th key={i} className='text-center'>{title}</th>
    ))

    return (
      <thead>
        <tr>
          {ths}
        </tr>
      </thead>
    )
  },

  renderHeaderWithTitles(headerTitles) {
    const ths = Object.keys(headerTitles).map((k, i) => (
      <th
        key={i + 1}
        className='fit text-center'
      >
        {headerTitles[k]}
      </th>
    ))

    return (
      <thead>
        <tr>{ths}</tr>
      </thead>
    )
  },


  renderRows(rows, excludedColumns, rowStyleArr, tdStyleArr) {
    return rows.map((row, index) => {
      // create an array of <td>
      const tds = Object.keys(row).map((key, kid) => {
        if (excludedColumns !== undefined && excludedColumns.includes(key))
          return

        const formattedValue = this.formatValue(row, key)
        const tdClass = isNaN(row[key]) ? "text-left" : "text-right"

        return (
          <td
            key={kid + 1}
            className={typeof formattedValue === 'object' ? "text-center" : tdClass}
            style={
              typeof tdStyleArr !== "undefined" && typeof tdStyleArr[key] !== "undefined"
                ? tdStyleArr[key]
                : null
            }
          >
            {formattedValue}
          </td>
        )
      })

      // add array of <td> to <tr>
      return (
        <tr
          key={index}
          style={
            typeof rowStyleArr !== "undefined" && rowStyleArr.length > 0
              ? rowStyleArr[index]
              : null
          }
        >
          {tds}
        </tr>
      )
    })
  },

  renderRowsWithIds(rows, excludedColumns) {
    return rows.map((row, index) => {
      // create an array of <td>
      const tds = Object.keys(row).map((key, kid) => {
        if (excludedColumns.includes(key)) return

        const formattedValue = this.formatValue(row, key)
        const tdClass = isNaN(row[key]) ? "text-left" : "text-right"
        return <td className={tdClass} key={kid + 1}>{formattedValue}</td>
      })

      // add id column to array of <td>
      const tdWithIds = [<td key={0} className="text-center" >{index + 1}</td>].concat(tds)
      return <tr key={index}>{tdWithIds}</tr>
    })
  },
  renderRows2(headerTitles, rows, options = { excludedColumns: [], moneyColumns: [] }) {
    if (headerTitles.length === 0 || rows.length === 0) return null

    return rows.map((row, index) => {
      // create an array of <td>
      const tds = Object.keys(headerTitles).map((key, kid) => {
        if (typeof options.excludedColumns !== 'undefined' && options.excludedColumns.includes(key))
          return

        const optionsSelect = [{"value": "ไม่ระบุ", "label": "ไม่ระบุ"}]
        const formattedValue =
            (typeof options.moneyColumns !== 'undefined' && options.moneyColumns.includes(key))
            ? moneyFormatter.format(row[key])
            : (typeof options[key] !== 'undefined')
            ? options[key][row[key] * 1]
            : row[key]
        const tdClass = isNaN(formattedValue) ? "text-left" : "text-right" 
        return <td className={tdClass} key={kid + 1}>{formattedValue}</td>
      })

      // add id column to array of <td>
      const tdWithIds = [<td key={0} className="text-center" >{index + 1}</td>].concat(tds)
      return <tr key={index}>{tds}</tr>
    })
  }
}

const directoryHelper = {

  walk_dirid(node,rindex){
    if(node.children !==undefined){
      //Is Dir
      let that = this
      node.id = rindex
      node.children.map((citem,cindex)=>{
        return that.walk_dirid(citem,node.id+'_'+cindex)
      })
    }
    return node
  },
  
  walk_action(node,action,targetId,srcFile){
    if(node.children !==undefined){
      //Is Dir    
      let that = this
      let dirIndex = 0;
      node.children = node.children.reduce((rresult,citem,cindex)=>{
        let removeFlag = false
        if(citem.id==targetId){
          if(action=='remove'){
            //Filter out
            removeFlag = true
          }
        }
        if(citem.children!==undefined){
          dirIndex++;
        }
        if(!removeFlag){
          rresult.push(that.walk_action(citem,action,targetId,srcFile))
        }
        return rresult
      },[])
  
      if(node.id==targetId){
        //True
        if(action=='paste'){
          if(srcFile.children!==undefined && srcFile.id===undefined){
            srcFile.id = targetId+'_'+dirIndex
          }
          node.children.push(srcFile)
        }else if(action=='open'){
          node['state'] = {'opened':true}
        }
      }
    }
    return node
  }
}


export { momentHelper, tableHelper, moneyFormatter ,directoryHelper}



// WEBPACK FOOTER //
// ./src/utils/helpers.js